import React, { useCallback, useEffect, useState } from 'react';
import Card from 'components/Card';
import Button from 'components/common/buttons/Button';
import { DataForm, Input, InputMask } from 'components/formik_inputs';
import {
  getDispensaDisciplina,
  createDispensaDisciplina,
  editDispensaDisciplina,
  deleteDispensaDisciplina,
} from '../../services/curricula-services';
import { toast } from 'react-toastify';
import { useHistory, useParams } from 'react-router-dom';
import { nativeGet as get, nativeGet } from 'utils';
import { PermissionContext } from 'hoc/withPermission';
import ButtonWithConfirmation from 'components/common/buttons/ButtonWithConfirmation';
import DynamicSelect from 'components/formik_inputs/custom-inputs/DynamicSelect';
import { InstitutionApi } from 'services/core';
import TextArea from 'components/formik_inputs/TextArea';
import InputHhMm from 'components/formik_inputs/custom-inputs/InputHhMm';
import PercentageInput from 'components/formik_inputs/custom-inputs/PercentageInput';
import { createNumberMask } from 'text-mask-addons';

const SemestreOptions = [
  { label: 'Anual', value: 0 },
  { label: 'Primeiro', value: 1 },
  { label: 'Segundo', value: 2 },
];

const DispensaDisciplinaFormPage = ({ ...props }) => {
  const { id } = useParams();
  const history = useHistory();
  const edit = window.location.pathname.includes('edit');
  const [initialData, setInitialData] = useState(false);

  useEffect(() => {
    if (edit && !initialData) {
      getDispensaDisciplina(id).then((data) =>
        setInitialData({
          ...data,
          period: SemestreOptions.find((op) => op.value === data?.period),
        })
      );
    }
  }, []);

  const submit = async (values) => {
    const data = {
      ...values,
      institution: get(values, 'institution.id'),
    };

    return editDispensaDisciplina(id, data).then((res) => {
      toast.success('Dispensa de disciplina editada com sucesso.');
      history.push('/dispensas/disciplinas');
    });
  };

  const handleDelete = useCallback(async () => {
    try {
      await deleteDispensaDisciplina(id);

      toast.success('Dispensa de disciplina excluída com sucesso.');
      history.push('/dispensas/disciplinas');
    } catch (err) {
      const error = get(err, 'response.data.detail', '');
      toast.error(
        error || 'Ocorreu um erro ao remover a dispensa de disciplina.'
      );
    }
  }, [id]);

  return (
    <Card
      title={
        id
          ? 'Editar Dispensa de Disciplina'
          : 'Adicionar Dispensa de Disciplina'
      }
    >
      <DataForm
        autoSetErrors
        initialValues={initialData || {}}
        onSubmit={submit}
        enableReinitialize
      >
        {(formik) => (
          <>
            <div className="card-deck">
              <div className="card-100 card-body">
                <div className="d-flex justify-space-between">
                  <p className="semi-bold brown text-underline">
                    Dispensa de Disciplina #{id}
                  </p>
                </div>
                <div className="d-flex align-items-center">
                  <div className="mb-1 mt-1">
                    <span className="brown">Curriculo:</span>{' '}
                    {initialData?.student_curriculum?.curriculum?.name}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="mb-1">
                    <span className="brown">Aluno:</span>{' '}
                    {initialData?.student_curriculum?.student?.name}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="mb-1">
                    <span className="brown">Disciplina:</span>{' '}
                    {initialData?.grid_discipline?.discipline?.nome}
                  </div>
                </div>
                <div className="d-flex align-items-center">
                  <div className="mb-2">
                    <span className="brown">Protocolo:</span>{' '}
                    {initialData?.ticket_id}
                  </div>
                </div>
              </div>
            </div>

            <DynamicSelect
              label="Instituição"
              name="institution"
              fetchFunction={() =>
                new InstitutionApi().list().then((data) => data.results)
              }
              getOptionValue={(o) => o.id}
              getOptionLabel={(o) => o.name}
              required
            />
            <InputMask
              label="Nota"
              name="grade"
              required
              mask={createNumberMask({
                prefix: '',
                suffix: '',
                decimalSymbol: ',',
                allowDecimal: true,
                includeThousandsSeparator: false,
                decimalLimit: 2,
                integerLimit: 3,
              })}
            />
            <InputHhMm label="Carga horária" name="hours" required />
            <Input
              type="text"
              name="completed_discipline_name"
              label="Disciplina Concluída"
              required
            />
            <InputMask
              mask={[/\d/, /\d/, /\d/, /\d/]}
              label="Ano de conclusão"
              placeholder="XXXX"
              name="completed_discipline_year"
              required
            />
            <TextArea label="Observações" name="note" />
            <div
              style={{
                width: '100%',
                height: 'auto',
                display: 'flex',
                justifyContent: 'space-between',
                paddingTop: '20px',
              }}
            >
              <Button
                onClick={() => history.push('/dispensas/disciplinas')}
                type="button"
              >
                Voltar
              </Button>
              <div>
                <PermissionContext.Consumer>
                  {({ hasPermission }) =>
                    hasPermission('curricula.delete_informeddiscipline') &&
                    edit && (
                      <ButtonWithConfirmation
                        action="danger"
                        confirmationText="Deseja excluir permanentemente essa Dispensa de disciplina ?"
                        onClick={handleDelete}
                      >
                        Excluir
                      </ButtonWithConfirmation>
                    )
                  }
                </PermissionContext.Consumer>
                <Button type="submit">Salvar</Button>
              </div>
            </div>
          </>
        )}
      </DataForm>
    </Card>
  );
};

export default DispensaDisciplinaFormPage;
